import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/home/home.vue'
import About from '@/views/about/about.vue'
import Query from '@/views/query/query.vue'
import QueryResult from '@/views/query-result/query-result.vue'
import Track from '@/views/track/Index.vue'
import Contact from '@/views/contact/contact.vue'
import MessageCenter from '@/views/message-center/message-center.vue'

// 关于线路的模块
import Belarus from '@/views/track/Belarus/Index.vue'
import Kazakhstan from '@/views/track/Kazakhstan/Index.vue'
import Mongolia from '@/views/track/Mongolia/Index.vue'
import Russia from '@/views/track/Russia/Index.vue'
import UKraine from '@/views/track/Ukraine/Index.vue'
import Uzbekistan from '@/views/track/Uzbekistan/Index.vue'

Vue.use(VueRouter)

//重写push
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

//重写replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

const exceptionRoute = [
  {
    path:'/302',
    name:'302',
    component:() => import('@/views/exception/302.vue')
  },
  {
    path:'/403',
    name:'403',
    component:() => import('@/views/exception/403.vue')
  },
  {
    path:'/404',
    name:'404',
    component:() => import('@/views/exception/404.vue')
  },
  {
    path:'/500',
    name:'500',
    component:() => import('@/views/exception/500.vue')
  },
]

const routes = [
  {
    path:'*',
    redirect:'/home',
  },
  {
    path:'/login',
    name:'login',
    component:() => import('@/views/login/index.vue')
  },
  {
    path:'/home',
    name:'home',
    component:Home,
    meta:{title:'首页',en:'HOME',ru:'Главная',uk:'HOME',needHeader:false,needFooter:true}
  },
  {
    path:'/about',
    name:'about',
    component:About,
    meta:{title:'关于我们',en:'ABOUT US',ru:'Про нас',uk:'ABOUT US',needHeader:true,needFooter:true}
  },
  {
    path:'/query',
    name:'query',
    component:Query,
    meta:{title:'物流查询',en:'QUERY',ru:'Оставьте запрос',uk:'QUERY',needHeader:true,needFooter:true}
  },
  {
    path:'/queryResult',
    name:'queryResult',
    component:QueryResult,
    meta:{title:'查询结果',en:'QUERY RESULT',ru:'QUERY RESULT',uk:'QUERY RESULT',needHeader:false,needFooter:false}
  },
  {
    path:'/workplace',
    name:'workplace',
    component:() => import('@/views/workplace/index.vue'),
    redirect:'/workplace/adminQueryResult',
    children:[
      {
        path:'adminQueryResult',
        name:'adminQueryResult',
        component:() => import('@/views/workplace/query-result/index.vue')
      },
      {
        path:'adminMessageCenter',
        name:'adminMessageCenter',
        component:() => import('@/views/workplace/message-center/index.vue')
      }
    ]
  },
  {
    path:'/track',
    name:'track',
    component:Track,
    redirect:'/track/russia',
    meta:{title:'运输线路',en:'TRACK',ru:'TRACK',uk:'TRACK',needHeader:true,needFooter:true},
    children:[
      {
        path:'russia',
        name:'russia',
        meta:{title:'俄罗斯',en:'TRACK',ru:'ДОСТАВКА В РОССИЮ',uk:'TRACK',needHeader:true,needFooter:true},
        component:Russia
      },
      {
        path:'belarus',
        name:'Belarus',
        meta:{title:'白俄罗斯',en:'TRACK',ru:'ДОСТАВКА В БЕЛАРУСЬ',uk:'TRACK',needHeader:true,needFooter:true},
        component:Belarus
      },
      {
        path:'kazakhstan',
        name:'kazakhstan',
        meta:{title:'哈萨克斯坦',en:'TRACK',ru:'ДОСТАВКА В КАЗАХСТАН',uk:'TRACK',needHeader:true,needFooter:true},
        component:Kazakhstan
      },
      {
        path:'mongolia',
        name:'mongolia',
        meta:{title:'蒙古国',en:'TRACK',ru:'ДОСТАВКА В МОНГОЛИЮ',uk:'TRACK',needHeader:true,needFooter:true},
        component:Mongolia
      },
      {
        path:'UKraine',
        name:'UKraine',
        meta:{title:'乌克兰',en:'TRACK',ru:'ДОСТАВКА В УКРАИНУ',uk:'TRACK',needHeader:true,needFooter:true},
        component:UKraine
      },
      {
        path:'Uzbekistan',
        name:'Uzbekistan',
        meta:{title:'乌兹别克斯坦',en:'TRACK',ru:'ДОСТАВКА В УЗБЕКИСТАН',uk:'TRACK',needHeader:true,needFooter:true},
        component:Uzbekistan
      },
    ]
  },
  {
    path:'/contact',
    name:'contact',
    component:Contact,
    meta:{title:'联系我们',en:'CONTACT US',ru:'Связаться с нами (контакты)',uk:'CONTACT US',needHeader:true,needFooter:true}
  },
  {
    path:'/MessageCenter',
    name:'messageCenter',
    component:MessageCenter,
    meta:{title:'留言中心',en:'MESSAGE CENTER',ru:'MESSAGE CENTER',uk:'MESSAGE CENTER',needHeader:false,needFooter:false}
  },
  ...exceptionRoute
]

const router = new VueRouter({
  mode:'hash',
  scrollBehavior (to, from, savedPosition) {
    // console.log(`to :`,to);
    // console.log(`from :`,from);
    // console.log(`savedPosition :`,savedPosition);

    return { x: 0, y: 0 }
  },
  routes
})


// 全局前置路由守卫
router.beforeEach((to, from, next) => {
  let isLogin = localStorage.getItem('admin-token')
  if(['/workplace','/workplace/adminQueryResult','/workplace/adminMessageCenter'].includes(to.path)){
    if(isLogin){
      next()
    }else{
      next({path:'/home'})
    }
  }else{
    next()
  }
})

export default router
